import React, { ReactNode, MouseEvent } from 'react'
import { StopsCard } from '../../../../components'
import { MapContainer } from '../../../../containers'
import { dateAsCalendar } from '../../../../helpers'
import { images } from '../../../../images'
import { IReservation } from '../../../../models'
import { LiteralsService } from '../../../../services'
import StyledSection from './styles'

interface IProps {
  reservation: IReservation
  onClick: () => void
  onFavoriteClick: () => void
  onQRClick: () => void
}

export const Card: React.FC<IProps> = ({ reservation, onClick, onFavoriteClick, onQRClick }) => {
  const cancelledLabel = reservation.cancelled
    ? (
      <div className="cancelled-label">
        <span>
          { LiteralsService.get('cancelled', true) }
        </span>
      </div>
      )
    : null

    const qrButton = (): ReactNode => {
      return (
        <button onClick={ handleQRClick }>
          <img src={ images['qrCode'] } alt='qr-code' />
        </button>
      )
    }

    const favoriteButton = (): ReactNode => {
      if (!reservation.favorite) {
        return (
          <button onClick={ handleFavoriteClick }>
            <img
              src={ images['star']}
              alt="Star"
            />
          </button>
        )
      } else {
        return (
          <img
            src={ images['starSelected']}
            alt="Star Selected"
          />
        )
      }
    }

    const handleFavoriteClick = (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      onFavoriteClick()
    }

    const handleQRClick = (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      onQRClick()
    }

  return (
    <StyledSection onClick={ onClick }>
      <div className="map">
        <MapContainer
          path={ reservation.path }
          inStop={ reservation.beginningStop }
          outStop={ reservation.seats[0].exitStop }
          serviceInfos={ [] }
          zoomLevel={ 13 }
          correction={ 0.000005 }
        />
      </div>
      { cancelledLabel }
      <div className="details">
        <header>
          <span className="date">
            { dateAsCalendar(reservation.beginningStop.dateTime) }
          </span>
          <div className="actions-buttons">
            { reservation.qrCode && qrButton() }
            { favoriteButton() }
          </div>
        </header>
        <div>
          <StopsCard
            inStopName={ reservation.beginningStop.name }
            outStopName={ reservation.seats[0].exitStop.name }
          />
        </div>
      </div>
    </StyledSection>
  )
}
